import { render, staticRenderFns } from "./v-tag.vue?vue&type=template&id=1beeccb3&scoped=true&"
import script from "./v-tag.vue?vue&type=script&lang=js&"
export * from "./v-tag.vue?vue&type=script&lang=js&"
import style0 from "./v-tag.vue?vue&type=style&index=0&id=1beeccb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beeccb3",
  null
  
)

export default component.exports